export default __webpack_public_path__ + "static/media/gh_logo_light.571d1ccb.svg";